import React, { useState } from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import AssessmentIcon from "@mui/icons-material/Assessment";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import LogoutIcon from "@mui/icons-material/Logout";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { NavLink } from "react-router-dom";
import UploadDialog from "./Dialogues/UploadDialog";
import ExportDataDialog from "./Dialogues/ExportDataDialog";
import logo from "../Assets/images/Swaasa.png";
import apollo from "../Assets/images/apollo.png";
import axios from '../axios';
import { createTheme, ThemeProvider } from "@mui/material";
import '../Assets/styles/newStyles/Navbar.css';

const drawerWidth = 240;
const theme = createTheme({
  overrides: {
    MuiListItem: {
      root: {
        "&$selected": {
          backgroundColor: "red",
        },
        "&:hover": {
          backgroundColor: "orange",
        },
      },
      selected: {},
    },
  },
});

function Adminsidebar(props) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = () => {
    localStorage.clear();
    props.history.push('/');
  };

  const handleExport = () => {
    setOpenExport(true);
  };

  const handleCloseExport = () => {
    setOpenExport(false);
  };

  const exportData = () => {
    // Export data logic here
  };

  const exportApolloData = () => {
    // Export Apollo data logic here
  };

  const handleUpload = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleListItemClick = (index) => {
    setSelectedItemIndex(index);
  };

  const icons = [
    <HomeIcon />,
    <PersonIcon />,
    <AnalyticsIcon />,
    <AssessmentIcon />,
    <CloudDownloadIcon />,
    <LogoutIcon />,
  ];

  const drawer = (
    <ThemeProvider theme={theme}>
      <img className="logo-img" src={logo} alt="logo" />
      <Toolbar />
      <Divider />
      <List>
        {[
          { text: "Home", to: "/admindashboard" },
          { text: "Doctors", to: "/doctoslist" },
          { text: "DH Executive", to: "/agentslist" },
          { text: "Patients", to: "/patients" },
          { text: "Imbrications", to: "/adminsettings" },
          { text: "Export", onClick: handleExport },
          { text: "Upload", onClick: handleUpload },
        ].map((item, index) => (
          <ListItem key={item.text} selected={selectedItemIndex === index} onClick={() => handleListItemClick(index)} disablePadding>
            {item.to ? (
              <NavLink to={item.to} style={{ textDecoration: "none", color: "inherit" }}>
                <ListItemButton>
                  <ListItemIcon>{icons[index]}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </NavLink>
            ) : (
              <ListItemButton onClick={() => item.onClick(index)}>
                <ListItemIcon>{icons[index]}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            )}
          </ListItem>
        ))}
        {localStorage.bulkupload === "true" && (
          <ListItemButton onClick={handleUpload}>
            <ListItemIcon>
              <UploadFileIcon />
            </ListItemIcon>
            <ListItemText primary="Upload" />
          </ListItemButton>
        )}
      </List>
    </ThemeProvider>
  );

  return (
    <ThemeProvider theme={theme}>
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mt: 0, mr: 2, display: { sm: "none" } }}
        >
          <MenuIcon sx={{ color: "orange", fontSize: 32 }} />
          <div className="sidebar">
            {localStorage.adminId === "admin@apollo.com" ? (
              <div className="sidebar__apollo">
                <img src={apollo} alt="Apollo Logo" />
              </div>
            ) : (
              <div className="sidebar__logo">
                <img src={logo} alt="Swaasa Logo" />
              </div>
            )}
          </div>
        </IconButton>
      </Toolbar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
        >
          {drawer}
        </Drawer>
      </Box>
      <ExportDataDialog
        openExport={openExport}
        handleCloseExport={handleCloseExport}
        handleExport={exportData}
        handleExportApollo={exportApolloData}
      />
      <UploadDialog open={open} handleClose={handleClose} />
    </ThemeProvider>
  );
}

Adminsidebar.propTypes = {
  history: PropTypes.object.isRequired,
};

export default Adminsidebar;
